import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../App/API/api";

export const fetchGalleryData = createAsyncThunk(
  "gallery/fetchData",
  async (perPage) => {
    try {
      const response = await api.get("/galleries", {
        params: {
          perPage: perPage,
        },
      });
      
      const data = response.data.gallaries;
    //   console.log(data)
      return data;
    } catch (error) {
      return error;
    }
  }
);

export const gallerySlice = createSlice({
  name: "gallery",
  initialState: {
    loading: false,
    error: null,
    galleries: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchGalleryData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchGalleryData.fulfilled, (state, action) => {
        state.loading = false;
        state.galleries = action.payload;
      })
      .addCase(fetchGalleryData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default gallerySlice.reducer;
